var fullpage = require('fullpage.js/dist/fullpage.extensions.min');
export let hbModal = {};
let currentEle;
let currentEleModal;

hbModal.init = () => {
  hbModal.closeBtnAction('js-modal-close');
  hbModal.closeBtnAction('js-modal-close-btn');
  hbModal.modalBtn('js-modal-button', 'hbModalBtn', true);
  hbModal.modalBtn('js-modal-item', 'forhbModalBtn', false);
}

hbModal.modalBtn = (e, name, bol) => {
  let ele = document.getElementsByClassName(e);

  for(let i = 0; i < ele.length; i++) {
    if(!ele[i]) return;

    ele[i].id = name + i;

    if(bol) {
      ele[i].addEventListener('click', (e) => {
        hbModal.modalBtnAction(e);
        hbModal.closeModal('js-modal-body');
        fullpage_api.setAllowScrolling(false);
      });
    }
  }
}

hbModal.modalBtnAction = (e) => {
  if (!e) return;
  currentEle = e.target.id;
  currentEleModal = "for" + e.target.id;

  if(!document.getElementById(currentEleModal).classList.contains('is-active')) {
    document.getElementById(currentEleModal).classList.add('is-active');
  } else {
    if(!currentEleModal == "for" + e.target.id) {
      document.getElementById(currentEleModal).classList.remove('is-active');
    }
  }

  // hbModal.checker(e.target.className, currentEle);
  hbModal.checker(document.getElementById(currentEleModal).className, currentEleModal);
}

//check btn which is active
hbModal.checker = (e, comparer) => {
  let eleBtn = document.getElementsByClassName(e);
  if (!eleBtn) return;

  for (let i = 0; i < eleBtn.length; i++) {
    if (eleBtn[i].id !== comparer) {
      eleBtn[i].classList.remove('is-active');
    }

    if (i > 10000) break;
  }
}

hbModal.closeBtnAction = (e) => {
  let ele = document.getElementById(e);
  if(!ele) return;

  ele.addEventListener('click' , () => {
    hbModal.closeModal('js-modal-body');
    fullpage_api.reBuild();
    fullpage_api.setAllowScrolling(true);
    fullpage_api.setAutoScrolling(true);
  });

  ele.addEventListener('touchstart' , () => {
    hbModal.closeModal('js-modal-body');
    fullpage_api.reBuild();
    fullpage_api.setAllowScrolling(true);
    fullpage_api.setAutoScrolling(true);
  });
}

hbModal.closeModal = (e) => {
  let eleParent = document.getElementsByClassName(e);
  if(!eleParent) return;

  for(let i = 0; i < eleParent.length; i++) {
    if(eleParent[i].classList.contains('is-active')) {
      eleParent[i].classList.remove('is-active');
      document.body.style.overflowY = "visible";
    } else {
      eleParent[i].classList.add('is-active');
      document.body.style.overflowY = "hidden";
    }
  }
}

// document.addEventListener('DOMContentLoaded', function () {
//   hbModal.init();
// });



// WEBPACK FOOTER //
// ./scripts/components/modal.js